"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _menu = require("../utilities/menu");
var _styles2 = require("../utilities/styles");
var _button = _interopRequireDefault(require("../button"));
var _excluded = ["children", "classes", "item", "isDrawerActive", "isActive", "bordered", "renderMenuItemImage"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var useClasses = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
    highContrast = _ref.accessibility.highContrast;
  return {
    menuLink: {
      padding: 0,
      gridRow: 1,
      color: "".concat(palette.site.mobile.contrastText, " !important"),
      '&:hover, &:focus': {
        color: "".concat(palette.site.mobile.contrastText, " !important")
      }
    },
    menuLinkActive: (0, _defineProperty2.default)({
      color: "".concat(palette.site.mobile.activeText, " !important"),
      '&:hover, &:focus': {
        color: "".concat(palette.site.mobile.activeText, " !important")
      }
    }, highContrast.mediaQuery('active'), {
      color: 'HighlightText !important',
      background: 'Highlight !important',
      '-ms-high-contrast-adjust': 'none',
      '&:hover, &:focus': {
        color: 'HighlightText !important'
      }
    }),
    menuLabel: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
      flexGrow: 1,
      textTransform: 'uppercase',
      textDecoration: 'none',
      fontStretch: 'condensed',
      fontWeight: 'bold',
      lineHeight: '1'
    },
    border: {
      border: "2px solid ".concat(palette.site.mobile.contrastText),
      borderRadius: '10px',
      padding: '14px',
      marginBottom: '10px',
      fontSize: '1em'
    }
  };
}, {
  classNamePrefix: 'TCUISiteMenuMobileItem'
});
var MobileMenuItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var children = _ref2.children,
    classes = _ref2.classes,
    item = _ref2.item,
    isDrawerActive = _ref2.isDrawerActive,
    isActive = _ref2.isActive,
    bordered = _ref2.bordered,
    renderMenuItemImage = _ref2.renderMenuItemImage,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var _classes = useClasses();
  var _isActive = !isDrawerActive && isActive;
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({}, rest, {
    ref: ref,
    item: item,
    "aria-label": (0, _menu.getItemLabel)(item),
    href: item.url,
    target: item.target,
    classes: (0, _styles2.mergeClasses)({
      root: (0, _clsx3.default)(item.classes, _classes.menuLink, (0, _defineProperty2.default)({}, _classes.menuLinkActive, _isActive)),
      label: _classes.menuLabel
    }, classes)
  }), children ? children : renderMenuItemImage(item, {
    isActive: _isActive,
    className: (0, _clsx3.default)((0, _defineProperty2.default)({}, _classes.border, bordered))
  }));
});
MobileMenuItem.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.object,
  isDrawerActive: _propTypes.default.bool,
  item: _propTypes.default.object.isRequired,
  bordered: _propTypes.default.bool
};
MobileMenuItem.defaultProps = {
  children: null,
  classes: null,
  isDrawerActive: false,
  bordered: false
};
var _default = MobileMenuItem;
exports.default = _default;